import * as React from "react";
const SvgBurger = (props) => /* @__PURE__ */ React.createElement("svg", { width: 48, height: 48, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "#444", strokeWidth: 2, strokeLinecap: "round", d: "M15 16h18M15 23h12M15 30h18" }));
export default SvgBurger;
